import { default as apigClientFactory } from "aws-api-gateway-client";

import { GLOBAL_CONSTANTS } from "../constants";

export const apigClient = apigClientFactory.newClient({
	apiKey: GLOBAL_CONSTANTS.AWS_API_GATEWAY_KEY,
	invokeUrl: GLOBAL_CONSTANTS.AWS_API_GATEWAY_INVOKE_URL,
	region: GLOBAL_CONSTANTS.AWS_API_GATEWAY_REGION
});
